/**
 * German market quote request form — sends identical notification emails
 * to sales@blackcatmusic.com and the customer via FormSubmit (_cc),
 * and submits to Shopify contact for admin records.
 */
(function () {
  const formWrapper = document.querySelector('.cart-custom-form');
  if (!formWrapper) return;

  const form = formWrapper.querySelector('form');
  const submitButton = form && form.querySelector('.quote-submit');
  if (!form || !submitButton) return;

  const requiredFields = form.querySelectorAll('input[required], textarea[required]');
  const successEl = formWrapper.querySelector('.cart-form-success');
  const SALES_EMAIL = 'sales@blackcatmusic.com';

  function isValid() {
    return Array.from(requiredFields).every((field) => field.value.trim());
  }

  function updateButtonState() {
    submitButton.disabled = !isValid();
  }

  function showSuccess() {
    if (successEl) {
      successEl.hidden = false;
      successEl.style.display = 'block';
    }
    form.querySelectorAll('.field, .quote-submit').forEach((el) => {
      el.style.display = 'none';
    });
    const heading = formWrapper.querySelector('h2');
    if (heading) heading.style.display = 'none';
  }

  requiredFields.forEach((field) => {
    field.addEventListener('input', updateButtonState);
  });
  updateButtonState();

  if (window.location.search.includes('quote_submitted=1')) {
    showSuccess();
    return;
  }

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (!isValid()) return;

    const originalText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Wird gesendet...';

    const formData = new FormData(form);
    const customerEmail = (formData.get('contact[email]') || '').trim();
    const firstName = (formData.get('contact[first_name]') || '').trim();
    const lastName = (formData.get('contact[last_name]') || '').trim();
    const remark = (formData.get('contact[remark]') || '').trim();
    const body = (formData.get('contact[body]') || '').trim();

    const fsData = new FormData();
    fsData.append('_subject', `DE Angebotsanfrage – ${firstName} ${lastName}`.trim());
    fsData.append('_cc', customerEmail);
    fsData.append('_template', 'table');
    fsData.append('_replyto', customerEmail);
    fsData.append('E-Mail', customerEmail);
    fsData.append('Vorname', firstName);
    fsData.append('Nachname', lastName);
    fsData.append('Bemerkung', remark);
    fsData.append('Warenkorb', body);

    const shopifyData = new FormData(form);

    try {
      const [fsResponse] = await Promise.all([
        fetch(`https://formsubmit.co/ajax/${SALES_EMAIL}`, {
          method: 'POST',
          body: fsData,
          headers: { Accept: 'application/json' },
        }),
        fetch('/contact', {
          method: 'POST',
          body: shopifyData,
          headers: { Accept: 'text/html' },
        }),
      ]);

      if (!fsResponse.ok) {
        throw new Error('Email delivery failed');
      }

      const url = new URL(window.location.href);
      url.searchParams.set('quote_submitted', '1');
      window.history.replaceState({}, '', url.toString());
      showSuccess();
    } catch (error) {
      console.error('Quote request error:', error);
      submitButton.disabled = false;
      submitButton.textContent = originalText;
      form.submit();
    }
  });
})();
